import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ButtonItem } from "../../../../../entities/UIEntities/ButtonItem";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_PARKER_FORM_STEPS,
  ADD_CHARGE_ACCOUNT_FORM_STEPS,
  INPUTS_PROPS,
  DISCOUNT_TYPE,
} from "../../../../../enums/Enums";
import { ListItem } from "../../../../../entities/UIEntities/ListItem";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { convertCurrencyToSymbol, phoneNumberToSend } from "../../../../../utils/CommonUtils";
import {
  getErrorMessage,
  isEmail,
  isNumber,
  isPhoneNumber,
  isRequired,
  isTextValid
} from "../../../../../utils/FormUtils";
import SwitchInput from "../../../Inputs/CustomInputs/SwitchInput";
import PhoneInputWithoutVerification from "../../../Inputs/CustomInputs/PhoneInputWithoutVerification";
import ScopesSelectInput from "../../../Inputs/CustomInputs/ScopesSelectInput";
import { Grid } from "@mui/material";
import SelectInput from "../../../Inputs/CustomInputs/SelectInput";
import TextInput from "../../../Inputs/CustomInputs/TextInput";
import classes from "../WizardForm.module.css";
import { getSiteByScopeId } from "../../../../../utils/UsersUtils";

const AddChargeAccountStep = (props) => {
  const [errors, setErrors] = useState({});
  const [stepHeader, setStepHeader] = useState(new StepHeaderEntity(
    props?.isEditMode ? Strings.STEPS_TITLES.EDIT_CHARGE_ACCOUNT_TITLE : Strings.STEPS_TITLES.CREATE_NEW_CHARGE_ACCOUNT_TITLE,
    Strings.STEPS_TITLES.CHARGE_ACCOUNT_SUB_TITLE,
    Icons.NEW_PARKER,
    null
  ));

  let discountTypeList = [    
    new ListItem(1, convertCurrencyToSymbol(props?.selectedSite?.billingCurrency), DISCOUNT_TYPE.CURRENCY /*props?.selectedSite?.billingCurrency*/),
    new ListItem(2,"%", DISCOUNT_TYPE.PERCENTAGE /*"Percentage"*/)
  ];

  useEffect(() => {
    if (props.currentStep === ADD_CHARGE_ACCOUNT_FORM_STEPS.CREATE_NEW_CHARGE_ACCOUNT) {
      const hasError = Object.values(errors).some((hasError) => hasError);
      props.handleCurrentStepValidity(hasError);
    }
  }, [errors]);
  
  useEffect(() => {
    store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
  }, [stepHeader]);

  useEffect(() => {
    validateStep();
  }, [props.site, props.role, props.currentStep, props.email, props.phoneNumber, props.dialingCode, props.chargeAccountName, props.contactFirstName, props.contactLastName, props.isFullValidation, props.discountType, props.amount, props.isStepSubmitted]);

  const validateStep = () => {
    const emailError = !isRequired(props.email).isValid || !isEmail(props.email).isValid;
    const phoneNumberError = !isRequired(props.phoneNumber).isValid || !isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)).isValid;
    const chargeAccountNameError = !isRequired(props.chargeAccountName).isValid;
    const contactFirstNameError = !isRequired(props.contactFirstName).isValid;
    const contactLastNameError = !isRequired(props.contactLastName).isValid;
    const discountTypeError = !props.isFullValidation && !isRequired(props.discountType).isValid;
    const amountError = !props.isFullValidation && (!isRequired(props.amount).isValid || !isNumber(props.amount).isValid);
    
    setErrors({
      email: emailError,
      phoneNumber: phoneNumberError,
      userTypeValue: !isRequired(props.role).isValid,
      siteValue: !isRequired(props.site).isValid,
      chargeAccountName: chargeAccountNameError,
      contactFirstName: contactFirstNameError,
      contactLastName: contactLastNameError,
      discountType: discountTypeError,
      amount: amountError
    });
  };

  const handleChange = (event) => {
    props.handleChange(event);
  };

  const handleScopeChange = (event) => {
    let selectedSiteByScope = getSiteByScopeId(props?.sites, event?.site.id);
    //let currency = selectedSiteByScope?.billingCurrency;
    const eventValue = { ["site"] : event?.site, ["selectedSite"] : selectedSiteByScope, ["discountType"] : DISCOUNT_TYPE.CURRENCY };
    props.handleChange(eventValue);
  };

  const handleDiscountTypeChange = (event) => {
    const eventValue = { ["discountType"] : event?.discountType, ["amount"] : "" };
    props.handleChange(eventValue);
  };

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  // if (props.currentStep !== ADD_PARKER_FORM_STEPS.INVITE_NEW_GMT) {
  //   return null;
  // }

  return (
    <div className={classes.stepContainer}>
      <ScopesSelectInput
        label={Strings.INPUT_LABELS.FACILITY}
        id={INPUTS_PROPS.SITE}
        onChange={handleScopeChange/*props.handleChange*/}
        disabled={props.isEditMode}
        list={props.scopesList} // list={props.sitesList}
        sitesData={props.sitesData} 
        value={props.scopesList?.length > 0 ? props.scopesList[0].id : 0} // value={props.sitesList?.length > 0 ? props.sitesList[0].id : 0}
        // handleError={handleError}
        // hasError={!isEmail(props.email).isValid}
        // errorMessage={getErrorMessage(isEmail(props.email))}
      />
      <TextInput
        label={Strings.INPUT_LABELS.CHARGE_ACCOUNT_NAME}
        id={INPUTS_PROPS.CHARGE_ACCOUNT_NAME}
        value={props.chargeAccountName}
        isStepSubmitted={props.isStepSubmitted}
        handleError={handleError} 
        onChange={props.handleChange}
        hasError={!isRequired(props.chargeAccountName).isValid}
        errorMessage={getErrorMessage(isRequired(props.chargeAccountName))}
      />
      <TextInput
        label={Strings.INPUT_LABELS.EMAIL}
        id={INPUTS_PROPS.EMAIL}
        value={props.email}
        isStepSubmitted={props.isStepSubmitted}
        handleError={handleError} 
        onChange={props.handleChange}
        hasError={!isRequired(props.email).isValid || !isEmail(props.email).isValid}
        errorMessage={getErrorMessage(isRequired(props.email)) ? getErrorMessage(isRequired(props.email)) : getErrorMessage(isEmail(props.email))}
      />
      <TextInput
        label={Strings.INPUT_LABELS.CONTACT_FIRSTNAME}
        id={INPUTS_PROPS.CONTACT_FIRSTNAME}
        value={props?.contactFirstName}
        isStepSubmitted={props.isStepSubmitted}
        handleError={handleError} 
        onChange={props.handleChange}
        hasError={!isRequired(props.contactFirstName).isValid}
        errorMessage={getErrorMessage(isRequired(props.contactFirstName))}
      />
      <TextInput
        label={Strings.INPUT_LABELS.CONTACT_LASTNAME}
        id={INPUTS_PROPS.CONTACT_LASTNAME}
        value={props?.contactLastName}
        isStepSubmitted={props.isStepSubmitted}
        handleError={handleError} 
        onChange={props.handleChange}
        hasError={!isRequired(props.contactLastName).isValid}
        errorMessage={getErrorMessage(isRequired(props.contactLastName))}
      />    
      <PhoneInputWithoutVerification
        label={Strings.INPUT_LABELS.PHONE_NUMBER}
        id={INPUTS_PROPS.PHONE_NUMBER}
        phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
        value={props.phoneNumber}
        isVerifyValidationNeeded={false}
        dialingCode={props.dialingCode}
        isPhoneVerified={props.isPhoneVerified}
        onChange={props.handleChange}
        handleError={handleError} 
        isStepSubmitted={props.isStepSubmitted}
        hasError={!isRequired(props.phoneNumber).isValid || !isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)).isValid}
        errorMessage={getErrorMessage(isRequired(props.phoneNumber)) ? getErrorMessage(isRequired(props.phoneNumber)) : getErrorMessage(isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)))}
      />
     
      <div className={classes.assignScopesContainer}>
        <div className={classes.stepTitle}>
          {Strings.STEPS_TITLES.VALIDATIONS_TITLE}
        </div>
        {/* <div className={classes.stepSubTitle}>
          {Strings.STEPS_TITLES.ASSIGN_SUB_TITLE}
        </div> */}

        <div className={classes.validationContainer}>
          <div>{Strings.FULL_VALIDATION}</div>
          <div className={classes.fullValidation}>
            <SwitchInput
                checked={props.isFullValidation}
                onChange={handleChange}
                leftText={"Non-Active"}
                rightText={"Active"}
                id={INPUTS_PROPS.IS_FULL_VALIDATION}
              />
          </div>
        </div>

        <div className={classes.validationContainer}>
          <div>{Strings.PARTIAL_VALIDATION}</div>
          <div className={classes.partialValidation}>
          <Grid container spacing={2}>
                <Grid item xs={4}>
                  <SelectInput
                    label={Strings.INPUT_LABELS.DISCOUNT_TYPE}
                    id={INPUTS_PROPS.DISCOUNT_TYPE}
                    onChange={handleDiscountTypeChange /*props.handleChange*/}
                    list={discountTypeList}
                    value={props?.discountType ? props?.discountType : ''}
                    defaultValue={''}
                    isStepSubmitted={props.isStepSubmitted}
                    handleError={handleError}
                    hasError={!isRequired(props.discountType).isValid}
                    errorMessage={getErrorMessage(isRequired(props.discountType))}
                  />
                </Grid>
                <Grid item xs={8}>
                  {props?.discountType !== DISCOUNT_TYPE.PERCENTAGE ? 
                    <TextInput
                        label={Strings.INPUT_LABELS.AMOUNT}
                        id={INPUTS_PROPS.AMOUNT}
                        type={"number"}
                        minValue={0}
                        maxValue={1000}
                        value={props?.amount}
                        onChange={props.handleChange}
                        isStepSubmitted={props.isStepSubmitted}
                        handleError={props.handleError}
                        hasError={!isRequired(props.amount).isValid || !isNumber(props.amount).isValid}
                        errorMessage={getErrorMessage(isRequired(props.amount)) || getErrorMessage(isNumber(props.amount))}
                    />
                   : 
                   <TextInput
                        label={Strings.INPUT_LABELS.AMOUNT}
                        id={INPUTS_PROPS.AMOUNT}
                        type={"number"}
                        minValue={0}
		                    maxValue={100}
                        value={props?.amount}
                        onChange={props.handleChange}
                        isStepSubmitted={props.isStepSubmitted}
                        handleError={props.handleError}
                        hasError={!isRequired(props.amount).isValid || !isNumber(props.amount).isValid}
                        errorMessage={getErrorMessage(isRequired(props.amount)) || getErrorMessage(isNumber(props.amount))}
                  />
                }
                </Grid>
            </Grid>
          </div>
        </div>
        
        <TextInput
          classesToAdd={classes.noteField}
          label={Strings.INPUT_LABELS.NOTES}
          id={INPUTS_PROPS.NOTES}
          defaultValue={''}
          value={props.notes}
          onChange={props.handleChange}
          isStepSubmitted={props.isStepSubmitted}
          handleError={handleError}
          hasError={!isTextValid(props.notes).isValid}
          errorMessage={getErrorMessage(isTextValid(props.notes))}
          // showTooltip={false}
          // tooltipTitle={Strings.TOOLTIP_INFO_TITLE.PERSONAL_ID}
          // tooltipText={Strings.TOOLTIP_INFO_TEXT.PERSONAL_ID}
        />

      </div>
    </div>
  )
};

export default AddChargeAccountStep;